import { ReactNode } from 'react';

import { LeftBorderContainer } from '../../../../../components/containers/LeftBorderContainer';

type SummaryCardProps = {
  title: string;
  isBeta?: boolean;
  count?: string;
  button?: ReactNode;
};

export const SummaryCard = ({
  title,
  isBeta,
  count,
  button
}: SummaryCardProps) => {
  return (
    <>
      <LeftBorderContainer maxWidth="md:tw-max-w-[352px] tw-shadow-xl">
        <div className="tw-flex tw-flex-col tw-gap-1 tw-text-center">
          <div className="tw-flex tw-gap-[0.63rem] tw-justify-center tw-items-center ">
            <p className="tw-font-bold tw-text-[1.25rem]">{title}</p>
            {isBeta ? (
              <p className="tw-bg-[#001E64] tw-top-[10px] tw-right-[10px] tw-absolute md:tw-ml-[17rem] md:tw-mb-[1rem] tw-text-white tw-text-[0.75rem] tw-w-[2.4375rem] tw-h-[1.5rem] tw-rounded-[0.46875rem] tw-flex tw-justify-center tw-items-center">
                Beta
              </p>
            ) : null}
          </div>
          {count ? (
            <p className="tw-text-[#146CFA] tw-font-bold tw-text-5xl">
              {count}
            </p>
          ) : null}
        </div>
        {button ? button : null}
      </LeftBorderContainer>
    </>
  );
};
